<header (click)="requestExpansion()" (keyup)="requestExpansion()" tabindex="0">
  <h2>
    <span>{{ title }}</span>
    @if (showWorkCount && count !== null) {
      <span class="work-count">({{ count }})</span>
    }
  </h2>
  @if (buttonText) {
    <button class="primary wide" (click)="buttonClick.emit()">
      {{ buttonText }}
    </button>
  }
  @if (expandable) {
    <button
      class="primary"
      [class.icon-only]="showIcons && !showText"
      [attr.aria-label]="(!expanded ? 'Expand' : 'Collapse') + ' ' + this.title"
    >
      @if (showText && !showIcons) {
        <span>{{ !expanded ? 'Expand' : 'Collapse' }}</span>
      }
      @if (!showText && showIcons) {
        <fa-icon [icon]="!expanded ? faPlus : faMinus" class="fa-lg"></fa-icon>
      }
    </button>
  }
</header>
<div
  class="content"
  [class.scrollable]="_scrollable"
  [class.collapse-modal]="collapseModals"
>
  <ng-content></ng-content>
</div>
